module.exports = __webpack_public_path__ + "img/ezp_orange.1c2767b0.png";